import { SphereBufferGeometry, MeshLambertMaterial, Mesh } from "three"

const createGlobe = (texture, globeProps) => {
  const geometry = new SphereBufferGeometry(
    globeProps.radius,
    globeProps.segments.w,
    globeProps.segments.h
  )
  const material = new MeshLambertMaterial({
    ...globeProps.material,
    map: texture,
  })
  const globe = new Mesh(geometry, material)

  return globe
}

export default createGlobe
